//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import dummyItem from '~/components/content/dummy/gallery_dummy.vue';
import userChecks from '~/mixins/userChecks';
export default {
  mixins: [userChecks],
  async fetch() {
    await this.$store.dispatch(
      'resourcesStore/getResources',
      this.queries.topVideos
    );
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: { queries } }) => queries,
      topVideos: ({ resourcesStore: { topVideos } }) => topVideos,
      loading: ({ resourcesStore: { loading } }) => loading,
    }),
  },
  components: {
    dummyItem,
  },
};
